import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const UserAddIcon = ({ sx, ...props }: SvgIconProps) => {
  return (
    <SvgIcon viewBox="0 0 23 22" sx={{ height: '23px', width: '22px', fill: 'none', ...sx }} {...props}>
      <path
        d="M11.5 14.2083H7.37504C6.09578 14.2083 5.45614 14.2083 4.93566 14.3662C3.76379 14.7217 2.84674 15.6388 2.49126 16.8106C2.33337 17.3311 2.33337 17.9707 2.33337 19.25M17.9167 19.25V13.75M15.1667 16.5H20.6667M13.7917 6.875C13.7917 9.15317 11.9449 11 9.66671 11C7.38853 11 5.54171 9.15317 5.54171 6.875C5.54171 4.59683 7.38853 2.75 9.66671 2.75C11.9449 2.75 13.7917 4.59683 13.7917 6.875Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export default UserAddIcon;
